export default __webpack_public_path__ + "static/media/gcash_logo.5e901c9c.svg";